import React, { useState } from 'react';
import { authApi } from '../utils/api';
import { AuthCard, AuthHeading, AuthError, AUTH_LINK } from './AuthLayout';
import { LoaderCircleIcon, MailIcon } from './icons/LucideIcons';

const ForgotPassword = ({ onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email.trim()) {
      setError('Email is required');
      setLoading(false);
      return;
    }

    try {
      await authApi.forgotPassword(email.trim());
      setSuccess(true);
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to send password reset email');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <AuthCard>
        <div className="grid h-10 w-10 place-items-center rounded-xl bg-floral-100 text-floral-700">
          <MailIcon size={20} />
        </div>
        <AuthHeading
          title="Check your email"
          sub="If an account with this email exists, a password reset link has been sent to it."
        />
        <button type="button" onClick={onBackToLogin} className="btn-primary btn-lg w-full">
          Back to sign in
        </button>
      </AuthCard>
    );
  }

  return (
    <AuthCard as="form" onSubmit={handleSubmit}>
      <AuthHeading title="Reset your password" sub="We'll email you a link to set a new one." />

      <div>
        <label htmlFor="email" className="input-label">Email</label>
        <input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          required
          className="input-field h-ctl-lg px-3.5 text-base sm:text-base"
          placeholder="you@yourshop.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      {error && <AuthError>{error}</AuthError>}

      <button type="submit" disabled={loading} className="btn-primary btn-lg mt-1 w-full">
        {loading ? (
          <>
            <LoaderCircleIcon size={18} className="animate-spin" />
            Sending email...
          </>
        ) : (
          'Send reset link'
        )}
      </button>

      <button
        type="button"
        onClick={onBackToLogin}
        className={`self-center text-[13px] ${AUTH_LINK}`}
      >
        Back to sign in
      </button>
    </AuthCard>
  );
};

export default ForgotPassword;